import { createStore } from 'vuex'

const aid: string = '60069de2d4a0e100333f71b8'

export default createStore({
    state: {
        aid: aid, // 活动id
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        yearData: null, // 年度报告数据
        hbData: null // 红包是否显示
    },
    mutations: {
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_YEARDATA (state, data) {
            state.yearData = data
        },
        SET_HBDATA (state, data) {
            state.hbData = data
        }
    },
    actions: {
    },
    modules: {
    }
})
